import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { updateAvatarUrl } from '../account/actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* updateAvatar({ payload: { updateData, handledErrors, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.profile.avatar_update, data: updateData, multipart: true });

    onSuccess && onSuccess();
    yield put(updateAvatarUrl(data.result.image));
    yield put(actions.updateAvatarDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updateAvatarFailed,
      handledErrors,
      endpoint: api.profile.avatar_update.url
    });
  }
}

function* removeAvatar( { payload: { onSuccess } } ) {
  try {
    const { data } = yield call(fetch, { api: api.profile.avatar_delete });

    onSuccess && onSuccess();
    yield put(actions.removeAvatarDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.removeAvatarFailed,
      endpoint: api.profile.avatar_delete.url
    });
  }
}

export const updateAvatarSaga = takeEvery(types.UPDATE_AVATAR_REQUEST, updateAvatar);
export const removeAvatarSaga = takeEvery(types.REMOVE_AVATAR_REQUEST, removeAvatar);